import { render, staticRenderFns } from "./VueDatatablePagination.vue?vue&type=template&id=538cbb8c"
import script from "./VueDatatablePagination.vue?vue&type=script&lang=js"
export * from "./VueDatatablePagination.vue?vue&type=script&lang=js"
import style0 from "./VueDatatablePagination.vue?vue&type=style&index=0&id=538cbb8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports